export class UploadResult {
    fileId: string;
    originalName: string;
    fileUrl: string;
}

export class DataFileUploadResult extends UploadResult {
    rowCount: number;
    errorCount: number;
    commonName: string;
}